import React from 'react';
import { Box } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';

/**
 * BarChartWidget - Renders a bar chart for categorical data
 * 
 * @param {Array} data - Array of data points with xLabel and yValue
 * @param {Object} config - Widget configuration (title, description, etc.)
 */
export default function BarChartWidget({ data, config, height = 300 }) {
  // Transform data for MUI X-Charts
  const xLabels = data.map(item => item.xLabel);
  const yValues = data.map(item => parseFloat(item.yValue));

  return (
    <Box>
      <BarChart
        xAxis={[{ 
          scaleType: 'band', 
          data: xLabels 
        }]}
        series={[
          {
            data: yValues,
            label: config.title,
            color: '#2e7d32',
          },
        ]}
        height={height}
        margin={{ top: 10, right: 10, bottom: 50, left: 60 }}
      />
    </Box>
  );
}
